class APIS {
    apis() {
        return {
            send_text_message: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/messages/send/text'
            },
            send_image_message: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/messages/send/image'
            },
            send_video_message: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/messages/send/video'
            },
            send_audio_message: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/messages/send/audio'
            },
            send_document_message: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/messages/send/document'
            },
            send_interactive_message: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/messages/send/interactive'
            },
            upload_from_path: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/upload-from-path'
            },

        };
    }
}

export default new APIS();